import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { omit, findIndex } from 'lodash/fp';
import { updateParamSort, sortJourneysData } from 'actions/assign';
import { Icon } from 'ui';

class Sort extends PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  get selectedIndex() {
    const { currentOption, currentJourneyOption, options } = this.props;
    const isJourneysContent = this.props.contentType === 1;

    return findIndex(
      isJourneysContent ? currentJourneyOption : currentOption,
      options,
    );
  }

  handleChange({ target }) {
    const { updateSort, options } = this.props;
    const option = omit('label', options[target.value]);

    if (this.props.contentType === 0) {
      updateSort(option);
    } else {
      this.props.sortJourneyData(option);
    }
  }

  renderOptions() {
    return this.props.options.map(({ label }, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <option key={i} value={i} children={label} />
    ));
  }

  render() {
    return (
      <div className="AssignModal-sortButton">
        <select
          className="NewButton NewButton--white"
          onChange={this.handleChange}
          value={this.selectedIndex}
          children={this.renderOptions()}
        />
        <div className="AssignModal-sortIcon">
          <Icon name="sort" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentOption: state.params.sort,
  currentJourneyOption: state.journeySort,
  contentType: state.contentType,
});

const mapDispatchToProps = dispatch => ({
  updateSort(option) {
    dispatch(updateParamSort(option));
  },
  sortJourneyData(option) {
    dispatch(sortJourneysData(option));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Sort);
